import { BLOCK_FORMATS } from '../../interface/custom-types'
import { TOOLBAR_BUTTONS } from '../../interface/IToolbar'

export const DISABLED_BLOCKS_BUTTONS = [BLOCK_FORMATS.expandBlockTitle]
export const DISABLED_TEXT_BUTTONS = []

const DISABLE_RULES_FOR_BUTTONS = {
  [TOOLBAR_BUTTONS.Size]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.FontSize]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.BulletedList]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.NumberedList]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.BlockQuote]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.CodeBlock]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.ExpandBlock]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.UploadImage]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.UploadFile]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.Link]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.LinkButton]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.Separator]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.HorizontalRule]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.IFrame]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.Action]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.Video]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.ColumnOptions]: [BLOCK_FORMATS.expandBlockTitle],
  [TOOLBAR_BUTTONS.Table]: [BLOCK_FORMATS.expandBlockTitle],
}

export const isButtonDisabled = (
  buttonName: TOOLBAR_BUTTONS,
  elementCursorPosition: BLOCK_FORMATS | undefined,
  toolbarDisabled: boolean
) => {
  return toolbarDisabled || !!DISABLE_RULES_FOR_BUTTONS[buttonName]?.includes(elementCursorPosition)
}
